import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Right-edge chevron affordance for cards that navigate on tap
 * (PD-14698). One shared component so weight/color/spacing stay
 * identical across the history surfaces and detail line items.
 * Decorative only — the card itself is the accessible button — so it's
 * hidden from assistive tech. Never add this to a card that doesn't
 * navigate; the chevron IS the "this opens something" signal.
 */
export function CardChevron(): JSX.Element {
	return (
		<FontAwesomeIcon
			icon={faChevronRight}
			aria-hidden="true"
			className="self-center shrink-0 text-xs text-brand-muted opacity-60"
		/>
	);
}
